var React = require('react');

function UserAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 144A144 144 0 1 1 256 0a144 144 0 0 1 144 144z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384 320h-55.1a174.1 174.1 0 0 1-145.8 0H128A128 128 0 0 0 0 448v16a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48v-16a128 128 0 0 0-128-128z","className":"fa-primary","key":2})]);
}

UserAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = UserAlt;

UserAlt.default = UserAlt;
